import React, { useEffect } from 'react';
import { useAppDispatch } from 'app/store';
import { setActionBtnTitle, setHeaderAction, setHeaderTitle } from 'features/ui/model/uiSlice';
import { SendOtpTable } from 'widgets/sendOTP';

export const SendOtpPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHeaderTitle('Отправка OTP'));
    dispatch(setHeaderAction('create'));
    dispatch(setActionBtnTitle('Добавить способ отправки'));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, []);

  return <SendOtpTable />;
};
